import { clsx } from "@/helpers/clsx";
import { createTwc } from "react-twc";

export const twc = createTwc({ compose: clsx });
